import React, { useEffect, useState } from 'react';
import {
  FACTION_CREATION_UNLOCK_AT,
  getFactionCreationRemaining,
  isFactionCreationAllowedEmail,
  isFactionCreationSeasonOpen,
} from '../utils/seasonGate';

const padTime = (value) => String(value).padStart(2, '0');

export default function SeasonCreationBanner({
  userEmail,
  className = '',
  compact = false,
}) {
  const [now, setNow] = useState(() => new Date());
  const isSeasonOpen = isFactionCreationSeasonOpen(now);
  const hasEarlyAccess = isFactionCreationAllowedEmail(userEmail);

  useEffect(() => {
    if (isSeasonOpen) return undefined;

    const intervalId = window.setInterval(() => {
      setNow(new Date());
    }, 1000);

    return () => window.clearInterval(intervalId);
  }, [isSeasonOpen]);

  if (isSeasonOpen) return null;

  const remaining = getFactionCreationRemaining(now);
  const unlockLabel = FACTION_CREATION_UNLOCK_AT.toLocaleString('it-IT', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Rome',
  });

  return (
    <section className={`season-creation-banner ${compact ? 'season-creation-banner--compact' : ''} ${className}`}>
      <div className="season-creation-banner__icon" aria-hidden="true">
        <i className="bi bi-hourglass-split"></i>
      </div>
      <div className="season-creation-banner__content">
        <span className="season-creation-banner__eyebrow">Nuova stagione</span>
        <h2>Il FantaWrestling riparte il 1° maggio alle 12:00</h2>
        <p className='small'>
          La nuova stagione iniziera {unlockLabel}.{' '}
          {hasEarlyAccess
            ? 'Il tuo account ha accesso anticipato alla creazione.'
            : 'Fino ad allora puoi creare e modificare il tuo profilo esplorando le novità.'}
        </p>
      </div>
      <div className="season-creation-banner__countdown" aria-label="Countdown alla nuova stagione">
        <div>
          <strong>{remaining.days}</strong>
          <span>giorni</span>
        </div>
        <div>
          <strong>{padTime(remaining.hours)}</strong>
          <span>ore</span>
        </div>
        <div>
          <strong>{padTime(remaining.minutes)}</strong>
          <span>min</span>
        </div>
        <div>
          <strong>{padTime(remaining.seconds)}</strong>
          <span>sec</span>
        </div>
      </div>
    </section>
  );
}
